
import api from "../utils/axios";

export async function getArticleCategories() {
    const response = await api.get(
        "/magazine-categories"
    );

    return response.data;
}